import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import AmountUtils from "../../Utils/AmountUtils";
import moment from "moment";
import FieldAgentReturnOrderStatusCard from "./FieldAgentReturnOrderStatusCard";
import AnalyticsService from "../../Services/AnalyticsService";
import Clamp from "react-multiline-clamp";
import StringUtils from "../../Utils/StringUtils";

const useStyles = makeStyles({
  cardParentContainer: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    background: "white",
    marginBottom: "16px",
  },
  cardStatusContainer: {
    display: "flex",
    flexDirection: "row",
    padding: "4px",
    alignItems: "center",
    justifyContent: "space-between",
    width: "auto",
    borderRadius: "4px",
  },
  farmerDetailContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "6px 0",
    padding: "0 10px",
  },
  farmerName: {
    fontWeight: "600",
    color: "black",
    marginBottom: "4px",
    marginRight: "4px",
    fontSize: "14px",
  },
  returnInfoContainer: {
    display: "flex",
    flexDirection: "row",
    margin: "6px 0",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 10px",
  },
  approvalPending: {
    background: "#F5E9E9",
    textAlign: "center",
    borderRadius: "0 0 10px 10px",
    padding: "4px 0",
    color: "#9D2123",
    fontSize: "12px",
  },
});

export default function FieldAgentReturnCard(props) {
  const styleClass = useStyles();
  const navigate = useNavigate();
  const returnData = props.data;

  const handleCardClick = () => {
    const analyticsData = {
      page: "Field Agent Return Orders",
      type: "Field Agent Return Card",
      tabName: props?.tabName,
    };
    AnalyticsService.pushEvent("Card Clicked", analyticsData);
    navigate(
      `/field-agent-returns/order-detail?returnOrderId=${returnData.orderId}`
    );
  };

  const getAddressAsAString = () => {
    if (returnData?.address) {
      const address = returnData.address;
      return `${address.taluka}, ${address.district}`;
    }
    return "";
  };

  const getCreatedDate = () => {
    const dateString = returnData?.createdOn;
    if (dateString) {
      const parsedDate = moment(dateString);
      return parsedDate.format("D MMM YYYY");
    }
    return "";
  };
  return (
    <Box
      className={styleClass.cardParentContainer}
      onClick={() => handleCardClick()}
    >
      <Box className={styleClass.farmerDetailContainer}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Clamp lines={1} maxLines={1}>
            <Typography className={styleClass.farmerName}>
              {returnData.farmerName}
            </Typography>
          </Clamp>
          <Typography sx={{ fontSize: "12px" }}>
            {StringUtils.convertToTitleCase(getAddressAsAString())} |{" "}
            {StringUtils.convertToTitleCase(getCreatedDate())}
          </Typography>
        </Box>
        <FieldAgentReturnOrderStatusCard status={returnData.status} />
      </Box>
      <Divider />
      <Box className={styleClass.returnInfoContainer}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography sx={{ fontSize: "12px" }}>
            Return Id : {returnData.orderId}
          </Typography>
        </Box>
        <Typography
          sx={{ color: "#00733E", fontWeight: "800", fontSize: "14px" }}
        >
          {AmountUtils.formatCurrency(returnData.returnableAmount)}
        </Typography>
      </Box>
      <Divider />
      <Typography sx={{ margin: "6px 0", padding: "0 10px", fontSize: "12px" }}>
        Created By : {returnData.createdBy}
      </Typography>
      <Typography sx={{ padding: "0 10px 10px 10px", fontSize: "12px" }}>
        Approver : {returnData.approver?.[0]?.emailId}
      </Typography>
      {returnData.approvalPendingFrom > 2 && (
        <Typography className={styleClass.approvalPending}>
          Approval pending since {returnData.approvalPendingFrom} days
        </Typography>
      )}
    </Box>
  );
}
